export default "/_next/static/fonts/Graphik-BoldItalic-a5053e7156f1dde26beeeb325609f455.woff";